import { computed } from "vue";

export interface ImagePair {
  header: string;
  footer: string;
  footerClass: string;
}

/**
 * Composable that provides random image pairs for report cover pages
 * @returns A computed property that returns a randomly selected image pair
 */
export default function useReportCoverImages(isHPS: boolean) {
  let imagePairs: ImagePair[] = [];

  if (isHPS) {
    imagePairs = [
      {
        header: "/img/cover-page/hps-octolock.png",
        footer: "/img/cover-page/summit-footer.png",
        footerClass: "summit-footer"
      },
      {
        header: "/img/cover-page/hps-scc.png",
        footer: "/img/cover-page/summit-footer.png",
        footerClass: "summit-footer"
      },
      {
        header: "/img/cover-page/hps-st2500-pump.png",
        footer: "/img/cover-page/summit-footer.png",
        footerClass: "summit-footer"
      },
      {
        header: "/img/cover-page/hps-thrust-chamber.png",
        footer: "/img/cover-page/summit-footer.png",
        footerClass: "summit-footer"
      }
    ];
  } else {
    imagePairs = [
      // This is the original image pair, commented out for now
      // {
      //   header: "/img/cover-page/cover-header-img.jpg",
      //   footer: "/img/cover-page/tigershark.png",
      //   footerClass: "tigershark"
      // },
      {
        header: "/img/cover-page/cover-header-img-pmm.png",
        footer: "/img/cover-page/summit-footer.png",
        footerClass: "summit-footer"
      },
      {
        header: "/img/cover-page/cover-header-img-acs.png",
        footer: "/img/cover-page/summit-footer.png",
        footerClass: "summit-footer"
      },
      {
        header: "/img/cover-page/cover-header-img-avenger.png",
        footer: "/img/cover-page/summit-footer.png",
        footerClass: "summit-footer"
      },
      {
        header: "/img/cover-page/cover-header-img-corsair.png",
        footer: "/img/cover-page/summit-footer.png",
        footerClass: "summit-footer"
      },
      {
        header: "/img/cover-page/cover-header-img-defender.png",
        footer: "/img/cover-page/summit-footer.png",
        footerClass: "summit-footer"
      },
      {
        header: "/img/cover-page/cover-header-img-digital.png",
        footer: "/img/cover-page/summit-footer.png",
        footerClass: "summit-footer"
      },
      {
        header: "/img/cover-page/cover-header-img-hydro.png",
        footer: "/img/cover-page/summit-footer.png",
        footerClass: "summit-footer"
      },
      {
        header: "/img/cover-page/cover-header-img-tiger.png",
        footer: "/img/cover-page/summit-footer.png",
        footerClass: "summit-footer"
      },
      {
        header: "/img/cover-page/cover-header-img-triton.png",
        footer: "/img/cover-page/summit-footer.png",
        footerClass: "summit-footer"
      }
    ];
  }

  const randomImagePair = computed(() => {
    const randomIndex = Math.floor(Math.random() * imagePairs.length);
    return imagePairs[randomIndex];
  });

  return randomImagePair;
}
